import {Pipe, PipeTransform} from '@angular/core';
import {TypeUtils} from "../utils/type-utils";

@Pipe({
    name: 'roundNumber',
    standalone: false
})
export class RoundNumberPipe implements PipeTransform {

  transform(number: number, fractionDigits: number = 2): number {
    if (TypeUtils.isNull(number)) return 0;
    return parseFloat(number.toFixed(fractionDigits));
  }

}
